/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Unified result for all Claude Code hook events with proper response structure
 */
export type ClaudeHookResult = {
  /**
   * Whether to continue (SessionStart only)
   */
  continue?: boolean | undefined;
  /**
   * Top-level block decision for UserPromptSubmit / PostToolUse / Stop / SubagentStop. Use 'block' to halt processing.
   */
  decision?: string | undefined;
  /**
   * Hook-specific output as JSON object
   */
  hookSpecificOutput?: any | undefined;
  /**
   * Reason accompanying decision; shown to the user (UserPromptSubmit) or Claude (PostToolUse/Stop).
   */
  reason?: string | undefined;
  /**
   * Reason if blocked (SessionStart only)
   */
  stopReason?: string | undefined;
  /**
   * Whether to suppress the hook's output
   */
  suppressOutput?: boolean | undefined;
  /**
   * Warning message shown to the user in the terminal
   */
  systemMessage?: string | undefined;
};

/** @internal */
export const ClaudeHookResult$inboundSchema: z.ZodMiniType<
  ClaudeHookResult,
  unknown
> = z.object({
  continue: z.optional(z.boolean()),
  decision: z.optional(z.string()),
  hookSpecificOutput: z.optional(z.any()),
  reason: z.optional(z.string()),
  stopReason: z.optional(z.string()),
  suppressOutput: z.optional(z.boolean()),
  systemMessage: z.optional(z.string()),
});

export function claudeHookResultFromJSON(
  jsonString: string,
): SafeParseResult<ClaudeHookResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ClaudeHookResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ClaudeHookResult' from JSON`,
  );
}
